import { dialogTypes } from '@/dialogs'
import React, { useCallback } from 'react'
import { Button } from 'reactstrap'
import Icon from '@/components/Icon'
import { useLocalization } from '@/hooks/localization'
import { useDialog } from '@/hooks/useDialog'

function useBackgroundJobMessageSeverity (backgroundJobMessages) {
  const maxSeverityValue = backgroundJobMessages ? Math.max(...backgroundJobMessages.map(x => x.severity)) : null

  if (maxSeverityValue === null) return ''

  switch (maxSeverityValue) {
    case 3:
    case 4:
      return 'danger'
    case 1:
      return 'info'
    default:
      return 'warning'
  }
}

function BackgroundJobMessagesButton ({ backgroundJobMessages, iconOnly }) {
  const { localize } = useLocalization()

  const severityDisplay = useBackgroundJobMessageSeverity(backgroundJobMessages)
  const openDialog = useDialog()

  const onOpenMessagesGrid = useCallback(() => {
    openDialog({
      dialogType: dialogTypes.bgJobMessages,
      width: 5000,
      backgroundJobMessages
    })
  }, [backgroundJobMessages, openDialog])

  return backgroundJobMessages && !!backgroundJobMessages.length &&
    <Button size='sm' color={severityDisplay} onClick={onOpenMessagesGrid}><Icon
      name={'error-alt'} /><span>{ !iconOnly && localize('Common.Detail') }</span></Button>
}

export { BackgroundJobMessagesButton, useBackgroundJobMessageSeverity }



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/backgroundJobMessagesButton.js